import { useRouter } from '@application/utils';
import type { AccordionTab } from '@presentation/components';
import { FaqAccordion } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { FaqAccordionControllerProps } from './types';

export * from './types';

export const FaqAccordionController: FC<FaqAccordionControllerProps> = (props) => {
  const { resource } = props;
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();

  const faqItems: AccordionTab[] | undefined = useMemo(() => {
    const itemsMap = translate(`faq.${resource}.items`, {
      returnObjects: true,
      defaultValue: '',
    });

    if (!itemsMap) return undefined;
    const items = Object.values(itemsMap) as any[];
    return items.map((item) => {
      return {
        title: item.title,
        content: (
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: item.text
                .replaceAll('$hrefJoinBuyer', routeLocationDescriptor('joinBuyer').pathname ?? '')
                .replaceAll('$hrefJoinBuyer', routeLocationDescriptor('joinBuyer').pathname ?? '')
                .replaceAll('$hrefLogin', routeLocationDescriptor('login').pathname ?? '')
                .replaceAll('$hrefLitters', routeLocationDescriptor('litterList').pathname ?? '')
                .replaceAll('$hrefBreeders', routeLocationDescriptor('breederList').pathname ?? '')
                .replaceAll('$hrefBreeds', routeLocationDescriptor('breedList').pathname ?? '')
                .replaceAll('$hrefArticles', routeLocationDescriptor('articleList').pathname ?? '')
                .replaceAll(
                  '$hrefArticleAgreement',
                  `${
                    routeLocationDescriptor('article').pathname
                  }comment-obtenir-un-numero-dagrement-/`,
                )
                .replaceAll(
                  '$hrefMtBookings',
                  routeLocationDescriptor('mtAppointments').pathname ?? '',
                )
                .replaceAll('$hrefMtLitters', routeLocationDescriptor('mtLitters').pathname ?? '')
                .replaceAll('$hrefQuiz', routeLocationDescriptor('quiz').pathname ?? '')
                .replaceAll('$hrefChart', routeLocationDescriptor('chart').pathname ?? '')
                .replaceAll(
                  '$hrefJoinBreeder',
                  routeLocationDescriptor('joinBreeder').pathname ?? '',
                )
                .replaceAll('$hrefStory', routeLocationDescriptor('story').pathname ?? '')
                .replaceAll('$hrefTeam', routeLocationDescriptor('team').pathname ?? ''),
            }}
          />
        ),
      };
    });
  }, [translate, resource, routeLocationDescriptor]);

  return <FaqAccordion tabs={faqItems as AccordionTab[]} />;
};
